import { selectors } from 'data'
import { connect, ConnectedProps } from 'react-redux'
import { isCompact } from 'utils'

import SignedOut from './template'

export type PropsType = ConnectedProps<typeof connector>

const mapStateToProps = (state) => ({
  isCompact: isCompact(selectors.app.getScreenWidth(state)),
  walletUrl: selectors.config.getConfig(state).walletUrl
})

const connector = connect(mapStateToProps)

export default connector(SignedOut)
